import { CLASSIFICATION_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';

const CLASSIFICATION_LEVELS_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.classification`],
  limit: undefined,
});

const classificationFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.classificationLevelsLabel',
  sourceCube: CLASSIFICATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: CLASSIFICATION_LEVELS_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${CLASSIFICATION_CUBE_NAME}.classification`]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.classificationLevelsPlaceholder',
  format: ({ value }) => {
    const v = value as string;
    return v === 'other' ? 'Other' : v;
  },
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CLASSIFICATION_CUBE_NAME}.classification`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default classificationFilter;
